
export default function Panel_Members_Search_P()
{
  return (
    <div>
      <h1>مدیریت اعضاء</h1>
    </div>
  );
}
